import React from 'react';
import { Trail } from '../../../../models/Trail';
import TrailBookmark from '../BookmarkItems/TrailBookmark';
import { BookmarkListContainer } from '../bookmarkStyles';

type TrailBookmarkProps = {
	trails: Trail[];
};
const TrailBookmarks: React.FC<TrailBookmarkProps> = ({ trails }) => {
	return (
		<BookmarkListContainer>
			{trails.map((trail) => {
				return <TrailBookmark key={trail.id} trail={trail} />;
			})}
		</BookmarkListContainer>
	);
};

export default TrailBookmarks;
